export const SixesIcon = () => {
    return (
        <svg
            width="19"
            height="20"
            viewBox="0 0 19 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.945 16.2026C16.2658 16.5958 15.4078 16.3456 15.0146 15.7021L13.3701 12.8422V12.8064C13.4416 12.6992 13.5131 12.592 13.5846 12.449C14.0136 11.734 14.2638 10.876 14.2638 9.94652C14.2638 9.19579 14.0851 8.44506 13.7634 7.80158C13.6919 7.69434 13.6561 7.55134 13.5846 7.44409L13.7991 7.80158L17.517 14.2364C17.8745 14.9514 17.6243 15.8094 16.945 16.2026Z"
                fill="url(#paint0_linear_2079_621)"
            />
            <path
                d="M18.4824 6.44298C18.4824 7.22946 17.8389 7.87295 17.0524 7.87295H13.7277C13.6562 7.7657 13.6205 7.6227 13.549 7.51545C12.7625 6.12124 11.2968 5.15603 9.65234 5.04878H17.0524C17.8389 5.01304 18.4824 5.6565 18.4824 6.44298Z"
                fill="url(#paint1_linear_2079_621)"
            />
            <path
                d="M4.93323 7.47974C4.50425 8.23047 4.25401 9.05269 4.25401 9.98217C4.25401 10.7329 4.43275 11.4836 4.75449 12.1271C4.82599 12.2344 4.86174 12.3774 4.93323 12.4846L4.71874 12.1271L1.00084 5.69228C0.607601 5.01305 0.857844 4.15507 1.53708 3.76183C2.21631 3.36859 3.07429 3.61884 3.46753 4.26232L5.11198 7.12225V7.15799C5.07623 7.26523 5.00473 7.37249 4.93323 7.47974Z"
                fill="url(#paint2_linear_2079_621)"
            />
            <path
                d="M9.259 14.9512H1.42996C0.643483 14.9512 0 14.3077 0 13.5213C0 12.7348 0.643483 12.0913 1.42996 12.0913H4.75462C4.82612 12.1986 4.86186 12.3416 4.93336 12.4488C5.71984 13.843 7.18555 14.8082 8.83001 14.9155C8.97301 14.9512 9.116 14.9512 9.259 14.9512Z"
                fill="url(#paint3_linear_2079_621)"
            />
            <path
                d="M13.5488 12.4846L13.3343 12.8421L9.61644 19.2769C9.2232 19.9562 8.36523 20.2064 7.68599 19.8132C7.00676 19.4199 6.79227 18.5619 7.14976 17.8827L8.79421 15.0228C8.93721 15.0228 9.04446 15.0228 9.18745 15.0228C10.9034 15.0228 12.3691 14.1648 13.2986 12.8778C13.4058 12.6991 13.4773 12.5919 13.5488 12.4846Z"
                fill="url(#paint4_linear_2079_621)"
            />
            <path
                d="M13.7634 7.83718C13.6919 7.72993 13.6561 7.58694 13.5847 7.47969C12.7982 6.08548 11.3325 5.12024 9.688 5.013L11.3682 2.11733C11.7614 1.4381 11.5112 0.580115 10.832 0.186875C10.1527 -0.206364 9.29476 0.0438792 8.90153 0.723111L5.14788 7.1222V7.15794C5.07638 7.26519 5.00488 7.37243 4.93338 7.51543C4.50439 8.26616 4.25415 9.08839 4.25415 10.0179C4.25415 10.7686 4.43289 11.5193 4.75463 12.1628C4.82613 12.2701 4.86188 12.413 4.93338 12.5203C5.71986 13.9145 7.18557 14.8797 8.83003 14.987C8.97302 14.987 9.08027 14.987 9.22326 14.987C10.9392 14.987 12.4049 14.129 13.3344 12.842C13.4059 12.7348 13.4774 12.6276 13.5489 12.4846C13.9779 11.7696 14.2281 10.9116 14.2281 9.98212C14.2281 9.23139 14.0494 8.48066 13.7634 7.83718ZM9.25902 12.1271C8.0793 12.1271 7.11407 11.1618 7.11407 9.98212C7.11407 8.8024 8.0793 7.83718 9.25902 7.83718C10.4387 7.83718 11.404 8.8024 11.404 9.98212C11.404 11.1618 10.4387 12.1271 9.25902 12.1271Z"
                fill="currentColor"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_2079_621"
                    x1="16.9534"
                    y1="15.9803"
                    x2="10.0695"
                    y2="4.63711"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="currentcolor" />
                    <stop offset="1" stopColor="currentcolor" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_2079_621"
                    x1="18.4398"
                    y1="6.42687"
                    x2="6.62011"
                    y2="6.42687"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="currentcolor" />
                    <stop offset="1" stopColor="currentcolor" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_2079_621"
                    x1="1.68829"
                    y1="3.97597"
                    x2="8.52277"
                    y2="15.909"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="currentcolor" />
                    <stop offset="1" stopColor="currentcolor" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_2079_621"
                    x1="0.280987"
                    y1="13.539"
                    x2="13.752"
                    y2="13.539"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="currentcolor" />
                    <stop offset="1" stopColor="currentcolor" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_2079_621"
                    x1="7.70966"
                    y1="19.6854"
                    x2="14.7915"
                    y2="7.79885"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="currentcolor" />
                    <stop offset="1" stopColor="currentcolor" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
